import { render, staticRenderFns } from "./PerguntasIcmsAntecipacao.vue?vue&type=template&id=5e5645e4&scoped=true&"
import script from "./PerguntasIcmsAntecipacao.vue?vue&type=script&lang=js&"
export * from "./PerguntasIcmsAntecipacao.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasIcmsAntecipacao.vue?vue&type=style&index=0&id=5e5645e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5645e4",
  null
  
)

export default component.exports